import { actions, getAllPlansAsync, getMyPlansAsync } from './slices';

export const PlansActions = {
  ...actions,
  getAllPlansAsync,
  getMyPlansAsync,
};

export * from './storage';
